import { AccountFunnelLayoutComponent } from './layout/account-funnel-layout.component';
import { Routes, RouterModule } from '@angular/router';
import { AccountFunnelDashboardComponent } from './dashboard/account-funnel-dashboard.component';
import { AccountFunnelStepsComponent } from './steps/account-funnel-steps.component';
import { AccountFunnelSettingsComponent } from './settings/account-funnel-settings.component';
import { AccountFunnelInboxesComponent } from './inboxes/account-funnel-inboxes.component';
import { AccountFunnelApplicationsComponent } from './applications/account-funnel-applications.component';
import { AccountFunnelResourcesComponent } from './resources/account-funnel-resources.component';
import { AccountFunnelAutomationComponent } from './automation/account-funnel-automation.component';
import { CanDeactivateGuard } from '../../shared/can-deactivate-guard/can-deactivate-guard';

const accountFunnelRoutes: Routes = [
  // Account routes
  {
    path: '',
    //outlet: 'Funnel',
    component: AccountFunnelLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      { path: 'dashboard', component: AccountFunnelDashboardComponent },
      {
        path: 'applications',
        component: AccountFunnelApplicationsComponent,
      },
      {
        path: 'steps',
        component: AccountFunnelStepsComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'inboxes', component: AccountFunnelInboxesComponent },
      { path: 'schedules', component: AccountFunnelAutomationComponent },
      { path: 'settings', component: AccountFunnelSettingsComponent },
      { path: 'resources', component: AccountFunnelResourcesComponent },
    ],
  },
];

export const AccountFunnelRouting = RouterModule.forChild(accountFunnelRoutes);
